import moment from "moment";

export const friendlyDateTime = (t) => {
  return moment(t).format("dddd, Do MMM YYYY h:mma");
};
